import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {Observable} from 'rxjs';
import { UtilService } from 'src/app/service/util';
import { DDA, DDALista } from '../interface/dda';
import { IFiltroListaDDA } from '../filter/filtro-lista-dda';

@Injectable({
  providedIn: 'root'
})
export class DDAService {

  constructor(
    private http: HttpClient,
    private utilService: UtilService) {
  }

  url = `${environment.urlApiProtheus}/wsrfindda`;

  getDDA(NFIGRECNO: number): Observable<DDA> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.get<DDA>(`${this.url}/${NFIGRECNO}`, httpOptions);
  }

  getDDALista(filtro: IFiltroListaDDA): Observable<DDALista> {
    const httpOptions = this.utilService.filtrosHttpOptions(filtro);
    return this.http.get<DDALista>(`${this.url}`, httpOptions);
  }

  postDDA(dados: DDA): Observable<DDA> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post<DDA>(`${this.url}`,dados, httpOptions);
  }

  deleteDDA(NFIGRECNO: number): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.delete(`${this.url}/${NFIGRECNO}`, httpOptions);
  }

}
